module.exports = __webpack_public_path__ + "img/part_story.f241cb7b.svg";